import React, { useState, useRef, useEffect } from "react";

interface IProps {
  items: { value: string; label: string; icon: string, description: string }[];
  onChange: (value: string) => void;
  classString?: string;
}

const DropDown: React.FC<IProps> = ({ items, onChange, classString }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // đóng khi click ngoài
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-block" }}
      className={classString}
    >
      
      {/* Button */}
      <button
        onClick={() => setOpen(!open)}
        type="button"
        className="btn btn-outline border-success text-success"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 12px",
          borderRadius: 8,
          background: "#fff",
          cursor: "pointer",
        }}
      >
        <i className="bi bi-file-earmark-excel text-success"></i> Xuất Excel ▾
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            width: 260,
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          {items.map((item) => (
            <div
              key={item.value}
              onClick={() => {
                onChange(item.value);
                setOpen(false);
              }}
              style={{
                display: "flex",
                gap: 12,
                padding: 12,
                cursor: "pointer",
                alignItems: "flex-start",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              {/* Icon */}
              <span style={{ fontSize: 20 }}><i className={`${item.icon} fs-2`} /></span>

              {/* Content */}
              <div className="text-start">
                <div style={{ fontWeight: 500 }}>{item.label}</div>
                <div className="text-muted">{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropDown;